import React, { useState } from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';

// Create a component to display the combined table with CleanedDataTable styling
const CombinedTableDisplay = ({ data }) => {
  const [hoveredRow, setHoveredRow] = useState(null); // Track the hovered row index
  
  if (!data || data.length === 0) return null;
  
  // Get all unique keys from the data
  const headers = Array.from(
    new Set(
      data.flatMap(item => Object.keys(item))
    )
  );
  
  // Define column header styles (from CleanedDataTable)
  const columnStyles = {
    backgroundColor: "#152C73", 
    color: "white", 
    fontWeight: "bold", 
    position: "sticky",
    top: 0,
    zIndex: 1,
    textAlign: "center",
    padding: "12px 16px", // Increased padding for better spacing
    borderBottom: "1px solid #ddd",
    borderRight: "1px solid #ffffff", // Add white vertical line between header columns
    minWidth: "120px", // Set minimum width for columns
  };

  // Define row styles with hover and alternating row colors (from CleanedDataTable)
  const rowStyles = (index) => ({
    backgroundColor:
      hoveredRow === index
        ? "#D1D5DB" // Hover color
        : index % 2 === 0
        ? "#E3E7ED" // Light gray for even rows
        : "#F1F5F9", // Lighter gray for odd rows
    cursor: "pointer", // Pointer cursor on hover
  });

  return (
    <div style={{ marginTop: '20px', marginBottom: '20px' }}>
      {/* <Typography variant="h6" gutterBottom>
        Combined Table Data
      </Typography> */}
      
      
      <TableContainer
        component={Paper}
        style={{
          maxHeight: '60vh',
          overflow: 'auto',
          margin: '0 auto',
          borderRadius: "8px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
        }}
      >
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell 
                  key={index} 
                  style={{
                    ...columnStyles,
                    borderRight: index < headers.length - 1 ? "1px solid #ffffff" : "none" // No border for last column
                  }}
                >
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map((row, rowIndex) => (
              <TableRow
                key={rowIndex}
                style={rowStyles(rowIndex)}
                onMouseEnter={() => setHoveredRow(rowIndex)} // Highlight row on hover
                onMouseLeave={() => setHoveredRow(null)} // Reset highlight on mouse leave
              >
                {headers.map((header, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    style={{
                      textAlign: "center",
                      padding: "10px 16px", // Increased padding for better spacing
                      borderBottom: "1px solid #ddd",
                      borderRight: cellIndex < headers.length - 1 ? "1px solid #e0e0e0" : "none", // Add light gray vertical line between data columns
                      fontWeight: "bold",
                      minWidth: "120px", // Set minimum width for cells
                      whiteSpace: "nowrap", // Prevent text wrapping
                      overflow: "hidden",
                      textOverflow: "ellipsis", // Add ellipsis for overflow text
                    }}
                  >
                    {row[header] !== undefined ? 
                      (row[header] === null || row[header] === NaN ? 
                        '' : String(row[header])) 
                      : ''}
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CombinedTableDisplay;
